
import { Navigate } from 'react-router-dom';
import React from 'react';
import Home from '../Pages/Home';
import Login from '../Pages/Login';
import OrgnisationSetup from '../Pages/OrgnisationSetup'
import UserManagement from '../Pages/UserManagement';
import { ControlSetup } from '../Pages/ControlSetup';
import { AnalyzerSetup } from '../Pages/AnalyzerSetup';
import { AssaySetup } from '../Pages/AssaySetup';
import SmtpSetup from '../Pages/SmtpSetup';
import { QcReport } from '../Pages/QcReport';
import Chart from '../Pages/Chart';
import Result from '../Pages/Result';
import Notifications from '../Pages/Notifications';
import ForgetPassword from '../Pages/ForgetPassword';
import ChangePassword from '../Pages/ChangePassword';
import BlankLayout from '../Components/BlankLayout';
import ResetPassword from '../Pages/ResetPassword';
import { AuthGuard } from '../Components/Authentication/AuthGuard';
import { Authenticated } from '../Components/Authentication/Authenticated';
import { MasterAuthGuard } from '../Components/Authentication/MasterAuthGuard';

export const Router = [
    {
        path: "/Login",
        element:<Authenticated component={<Login />} /> ,
    },{
        element: <BlankLayout />,
        children:[
            { path: "/forgetpassword",  element:<ForgetPassword/>},
            { path: "/auth/reset-password",  element:<ResetPassword/>},
        ]
    
    },
    {
        path: "/",
        element:<Home /> ,
        children:[
            
            { path: '/', element: <Navigate to="/controlGraph" /> },
            { path: "/organisationSetup",  element: <AuthGuard component={<OrgnisationSetup />} adminProtected={true}/>},
            { path: "/userManagement", element: <AuthGuard component={<UserManagement />} adminProtected={true} /> },
            { path: "/controlSetup", element: <AuthGuard component={<ControlSetup />} adminProtected={true}/> },
            { path: "/analyzerSetup", element: <AuthGuard component={<AnalyzerSetup />} adminProtected={true}/>  },
            { path: "/smtpSetup", element: <MasterAuthGuard component={<SmtpSetup />} /> },
            { path: "/assaySetup", element: <AuthGuard component={<AssaySetup />} adminProtected={true}/>},
            { path: "/qcReport", element: <AuthGuard component={<QcReport />} />},
            { path: "/result", element: <AuthGuard component={<Result />} />},
            { path: "/controlGraph", element: <AuthGuard component={<Chart />} />},
            { path: "/notifications", element: <AuthGuard component={<Notifications />} />},
            { path: "/changePassword", element: <AuthGuard component={<ChangePassword />} />},
            { path: '*', element: <Navigate to="/" /> },
            
        ]
    }
] 